import { type User, REMINDER_OFFSETS_DAYS_DEFAULT } from '@/core/domain';
import type { UserRepository } from '../repositories/user-repository';
import type { CreateReminderSettingsUseCase } from '@/features/app/reminder-settings/domain/usecases/create-reminder-settings';
import { FirebaseAuthService } from '@/core/services/authentication/firebase-auth.service';

const DEFAULT_REMINDER_MESSAGE =
  'Olá! Passando para lembrar que está na hora da manutenção preventiva do seu ar-condicionado. Posso agendar para você?';

const DEFAULT_NOTIFICATION_TIME = '09:00';

export class CreateUserUseCase {
  constructor(
    private readonly firebaseAuthService: FirebaseAuthService,
    private readonly repository: UserRepository,
    private readonly createReminderSettings: CreateReminderSettingsUseCase
  ) {}

  async execute(user: User): Promise<User> {
    const userEmail = user.email;
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console -- diagnóstico local
      console.debug('[RetornaAr:CreateUser] entrada', {
        uid: user.id,
        emailNoDto: user.email ?? null,
      });
    }
    if (!userEmail) {
      const emailFromAuth = this.firebaseAuthService.resolveAccountEmail(
        this.firebaseAuthService.getAuth().currentUser
      );
      if (import.meta.env.DEV) {
        // eslint-disable-next-line no-console -- diagnóstico local
        console.debug('[RetornaAr:CreateUser] e-mail ausente no DTO — tentativa Auth', {
          uid: user.id,
          emailFromAuth: emailFromAuth ?? null,
          currentUserUid: this.firebaseAuthService.getCurrentUserUid(),
        });
      }
      if (!emailFromAuth) {
        throw new Error('Email não encontrado');
      }
      user.email = emailFromAuth;
    }
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console -- diagnóstico local
      console.debug('[RetornaAr:CreateUser] antes de repository.create', {
        uid: user.id,
        email: user.email ?? null,
      });
    }
    const created = await this.repository.create(user);
    const now = new Date().toISOString();
    const settings = {
      id: created.id,
      user_id: created.id,
      reminder_offsets_days: [...REMINDER_OFFSETS_DAYS_DEFAULT] as [number, number],
      preferred_notification_time: DEFAULT_NOTIFICATION_TIME,
      message_test_sended: false,
      message_test_outbound_wamid: null,
      created_at: now,
      updated_at: now,
    };
    await this.createReminderSettings.execute(created.id, settings);
    return created;
  }
}
